function get_saved_active_tab(tabs = []) {
  const saved_tab = localStorage.getItem("active_tab");
  return saved_tab && tabs.includes(saved_tab) ? saved_tab : "";
}

export default {
  methods: {
    should_auto_assign_template() {
      return this.$route.query.auto_assign === "true" && this.$route.query.entity_type_id;
    },
    sync_active_tab_from_storage() {
      const saved_tab = get_saved_active_tab(this.tabs);
      if (saved_tab) {
        this.active_tab = saved_tab;
        return;
      }
      if (!this.tabs.includes(this.active_tab)) {
        this.active_tab = this.tabs[0] || "Job Adverts";
      }
    },
    async load_active_tab_data() {
      if (this.active_tab === "Templates") {
        await Promise.all([
          this.get_assigned_templates(),
          this.view_signing_workflow(),
        ]);
        return;
      }
      if (this.active_tab === "Job Forms") {
        this.get_forms();
        this.initialize_data_table();
        return;
      }
      if (this.active_tab === "Job Adverts") {
        await this.get_job_adverts();
      }
    },
    async load_auto_assign_template_state() {
      this.show_success("Template uploaded and assigned successfully");
      this.active_tab = "Templates";
      localStorage.setItem("active_tab", "Templates");
      await Promise.all([
        this.get_assigned_templates(),
        this.view_signing_workflow(),
      ]);
      this.$router.replace({ query: null });
    },
  },
};
